import { ReportsHeader } from "./components/ReportsHeader";
import { ReportsTable } from "./components/ReportsTable";

export const ReportsManagement = () => (
  <div>
    <ReportsHeader />
    <ReportsTable />
  </div>
);